import Inputs from './inputs/index.js'
import Container from './container/index.js'
import Content from './contents/index.js'

export default {
  install (Vue) {
    for (let key in Inputs) {
      Vue.component(key, Inputs[key])
    }
    for (let key in Container) {
      Vue.component(key, Container[key])
    }
    for (let key in Content) {
      Vue.component(key, Content[key])
    }
  }
}
